// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9287":"e6a3d1cf66f0ddf4","65031":"29acb5bdccbbe8f4","77628":"20d6bb02fec47021"}[chunkId] + ".css";
};